import { c as _c } from "react/compiler-runtime";
import { CustomUrlBlock as CustomUrlBlockGraphQlType } from "common/types/graphql";
import { CustomUrlBlock as CommonCustomUrlBlock, CustomUrlBlockProps } from "common/components/CustomUrlBlock";
export type CustomUrlBlockFrontendBlock = CustomUrlBlockProps & Omit<CustomUrlBlockGraphQlType, "image">;
export const CustomUrlBlock = props => {
  "use memo";

  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <CommonCustomUrlBlock {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};